import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-check",
  "use": "gw-check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-check\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M9 16.17 5.53 12.7a.996.996 0 1 0-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71a.996.996 0 1 0-1.41-1.41z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol